import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import storage from 'redux-persist/lib/storage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { baseApi } from '@/lib/api/baseApi';
import { telegramApi } from '@/lib/services/telegramApi';

const persistConfig = {
  key: 'ThreatInformant-root',
  version: 1,
  storage,
  // 1. baseApi handles threatFeedsApi now, so we only need baseApi.reducerPath here
  blacklist: [baseApi.reducerPath, telegramApi.reducerPath],
};

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [telegramApi.reducerPath]: telegramApi.reducer,
  // 2. Removed the duplicate threatFeedsApi reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(baseApi.middleware)
      .concat(telegramApi.middleware),
  // 3. Removed the duplicate threatFeedsApi middleware
});

export const persistor = persistStore(store);
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;